module.exports = __webpack_public_path__ + "img/6-fontane-pirotecniche.d1acde7a.jpg";